import {
  BLOG_TYPE,
  EVENT_TYPE,
  LARGE,
  NEWS_TYPE,
  UPDATE_TYPE,
  SMALL,
} from "shared/constants";
import { CardsContainer } from "components/CardsContainer";
import { CategoriesBar } from "components/CategoriesBar";
import { MaxWidth } from "components/MaxWidth";
import { OVERVIEW, NEWS, EVENTS, BLOG, translate } from "shared/translate";
import { OverviewIntro } from "components/OverviewIntro";
import { Page } from "components/Page";
import { Spacing } from "components/Spacing";
import { useRouter } from "next/router";

export const NewsEventsOverviewPage = ({
  blogs,
  events,
  footer,
  intro,
  mirrorPath,
  navigation,
  news,
  seo,
  title,
}) => {
  const { locale } = useRouter();
  const categories = [
    {
      isActive: true,
      name: translate(OVERVIEW, locale),
      type: UPDATE_TYPE,
      slug: "",
    },
    {
      isActive: false,
      name: translate(NEWS, locale),
      type: NEWS_TYPE,
      slug: "",
    },
    {
      isActive: false,
      name: translate(EVENTS, locale),
      type: EVENT_TYPE,
      slug: "",
    },
    {
      isActive: false,
      name: translate(BLOG, locale),
      type: BLOG_TYPE,
      slug: "",
    },
  ];

  return (
    <Page
      description={seo?.description || intro}
      footer={footer}
      hasNewsletter
      image={seo?.image}
      mirrorPath={mirrorPath}
      navigation={navigation}
      title={seo?.title || title}
    >
      <MaxWidth size={LARGE}>
        <Spacing size={SMALL}>
          <OverviewIntro description={intro} title={title} />
        </Spacing>
        <CategoriesBar
          items={categories.map(({ isActive, name, slug, type }) => ({
            isActive,
            label: name,
            href: slug,
            type,
          }))}
        />
        <Spacing size={SMALL}>
          <CardsContainer
            items={news
              .slice(0, 1)
              .map((post) => ({ ...post, featured: true }))}
          />
        </Spacing>
        <Spacing size={SMALL}>
          <CardsContainer
            allLinkType={NEWS_TYPE}
            title={translate(NEWS, locale)}
            items={news.slice(1)}
          />
        </Spacing>
        <Spacing size={SMALL}>
          <CardsContainer
            allLinkType={EVENT_TYPE}
            title={translate(EVENTS, locale)}
            items={events}
          />
        </Spacing>
        <Spacing size={SMALL}>
          <CardsContainer
            allLinkType={BLOG_TYPE}
            title={translate(BLOG, locale)}
            items={blogs}
          />
        </Spacing>
      </MaxWidth>
    </Page>
  );
};
